import { render, staticRenderFns } from "./vueeventlist.vue?vue&type=template&id=52c31894&scoped=true"
import script from "./vueeventlist.vue?vue&type=script&lang=js"
export * from "./vueeventlist.vue?vue&type=script&lang=js"
import style0 from "./vueeventlist.vue?vue&type=style&index=0&id=52c31894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c31894",
  null
  
)

export default component.exports